import { Button, Card, CardActions, CardContent, Typography } from "@mui/material"
import React from "react"
import { useNavigate } from "react-router-dom";

export const MetricsCard = ({ title, showMore, count, processed = 0, working = 0, link }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(link);
    };

    return (
        <Card sx={{ minWidth: 300 }} raised={true} style={{ marginRight: 20 }}>
            <CardContent sx={{ minHeight: 150 }}>
                <Typography gutterBottom variant="h6" component="div">
                    {title}
                </Typography>
                <Typography variant="body1" color={count > 0 ? "warning.main" : "text.secondary"}>
                    {count} new
                </Typography>
                {showMore == true &&
                    <>
                        <Typography variant="body1" color={working > 0 ? "info.dark" : "text.secondary"}>
                            {working} working
                        </Typography>
                        <Typography variant="body1" color={processed > 0 ? "success.dark" : "text.secondary"}>
                            {processed} processed
                        </Typography>
                    </>
                }
            </CardContent>
            <CardActions>
                <Button size="medium" onClick={handleClick}>View</Button>
            </CardActions>
        </Card>
    )
}